import apiService from '@/member/services/apiService'
import { create } from 'lodash'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getCustomColumns({ commit }, payload) {
    const apiResult = await apiService.get(route('member.account.custom_columns'))
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async getAccountList({ commit }, payload) {
    const apiResult = await apiService.get(route('member.account.index'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async getAccountEdit({ commit }, payload) {
    const apiResult = await apiService.get(route('member.account.show', payload))
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async create({ commit }, payload) {
    return await apiService.post(route('member.account.create'), payload)
  },
  async update({ commit }, payload) {
    return await apiService.post(route('member.account.update'), payload)
  },
  async delete({ commit }, payload) {
    return await apiService.post(route('member.account.delete'), payload)
  },
  async createPassword({ commit }, payload) {
    return await apiService.post(route('member.account.create_password'), payload, false)
  },
  async getMembersOfDivision({ commit }, payload) {
    const apiResult = await apiService.get(route('member.account.member_of_division', payload))
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
}

export default {
  state,
  mutations,
  actions,
}
